// src/pages/KYCApplicationPage.jsx
import React, { useEffect, useState } from "react";
import Header from "./Header/header";
import { useSelector } from "react-redux";
import callApi from "../../../utility/apiCaller";
import Spinner from "./Spinner/spinner";
import { AlertCircle } from "lucide-react";
import { toast } from "react-toastify";

export default function KYCApplicationPage({ setCurrentStep, currentStep }) {
  const [loading, setLoading] = useState(false);
  const [callBackInProcess, setCallBackInProcess] = useState(false);
  const [kycFailed, setKycFailed] = useState(false);
  const [kycFailedByNotTry, setkycFailedByNotTry] = useState(false);
  //const [kycUrl, setKycUrl] = useState(null);

  // Fetch IDs from slice
  const aaSlice = useSelector((state) => state?.aa);
  //console.log(aaSlice);
  const appId = aaSlice?.appId;
  const leadId = aaSlice?.internalLeadId;
  const leadId1 = aaSlice?.leadId;
  const responseId = aaSlice?.responseId;
  const kycUrl = aaSlice?.kycUrl;
  //console.log(`appId:,${appId} leadId:${leadId}, responseId:${responseId}`);
  //console.log(kycUrl);
  const user = useSelector((state) => state.app.user);
  const InternalLeadId = aaSlice?.internalLeadId;
  // useEffect(() => {
  //   // check if we already refreshed once
  //   const alreadyRefreshed = sessionStorage.getItem("kycPageRefreshed");

  //   if (!alreadyRefreshed) {
  //     sessionStorage.setItem("kycPageRefreshed", "true");
  //     window.location.reload();
  //   }
  // }, []);

  console.log("appId:", appId);
  console.log("leadId:", leadId);
  console.log("responseId:", responseId);
  console.log("kycUrl:", kycUrl);

  useEffect(() => {
    if (kycUrl) return;
    // Fetch KYC URL from API
    const fetchKycUrl = async () => {
      try {
        setLoading(true);
        let res = await callApi(
          "v1/lender/kyc-service?lender_id=67b82660c4058e568491673c",
          "post",
          {
            lenderResponseID: responseId,
            dmi_lead_id: leadId1,
            application_id: appId,
            id: InternalLeadId,
          },
          "loan"
        );
        //console.log(res);
        // res = {
        //   status: "Success",
        //   data: {
        //     statuscode: 200,
        //     body: {
        //       kycurl:
        //         "https://dmikyc-uat.dmifinance.in/KYC-V3.0/?key=68a6b706e4394",
        //       leadid: "00Q9H00000E24PGUAZ",
        //       applicationid: "68827bdb55a5aa656ebJ7867",
        //     },
        //   },
        // };
        const url = res?.data?.body?.kycurl; // replace with actual response field
        // if (url) setKycUrl(url);
        await callApi(
          `v1/lead/${leadId}/update-lead-new`,
          "post",
          {
            lead: {
              kycurl: url,
            },
          },
          "core",
          user?.token ||
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTJlYzhmY2NjZTMzMjg0NWE2NWJkMDIiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wMlQxMToxOTo0Ny45MDdaIiwiaWF0IjoxNzY0NjczNzk0fQ.R4ctBZN6JkcXJnwjpeT6Z9_IYRmT76oy4RhcQkG4o"
        );

        if (url) {
          window.location.href = url; // Redirect user to KYC URL in the same tab
        }
      } catch (err) {
        console.error("Error fetching KYC URL", err);
      } finally {
        setLoading(false);
      }
    };

    if (appId && leadId && responseId) {
      fetchKycUrl();
    }
  }, [appId, leadId, responseId]);

  useEffect(() => {
    if (!kycUrl) return; // start polling only after URL is ready

    if (kycUrl) {
      let currentUrl = window.location.href;
      const fixedUrl = currentUrl.replace("?Status", "&Status");

      const parsedUrl = new URL(fixedUrl);
      // const status = parsedUrl.searchParams.get("Status");
      // console.log(urlParams);
      const status = parsedUrl.searchParams.get("Status");
      console.log(status);
      console.log(kycFailedByNotTry);
      if (status === "Failed" || !status) {
        setkycFailedByNotTry(true);
        return;
      } else {
        setkycFailedByNotTry(false);
      }
    }

    setCallBackInProcess(true);
    let intervalId;
    let attempts = 0;
    const maxAttempts = 10; // 5 minutes max

    const checkKYCStatus = async () => {
      attempts++;
      try {
        let res = await callApi(
          "v1/callback/list",
          "post",
          {
            filters: {
              event: "EKYC_Callback",
              applicationid: appId,
            },
          },
          "loan-service"
        );

        const callbackData = res?.data || {};
        const callbacks = Array.isArray(callbackData.callbackList)
          ? callbackData.callbackList
          : [];

        const decision = callbackData?.callbackList?.[0]?.kycdecision;
        const hasSuccess = res?.status;

        console.log("callbackData", callbackData);

        // ✅ Approved condition
        if (
          hasSuccess === "Success" &&
          decision === "Approved" &&
          callbackData.callbackCount > 0
        ) {
          clearInterval(intervalId);
          await callApi(
            `v1/lead/${leadId}/update-lead-new`,
            "post",
            {
              lead: {
                is_kyc_completed: true,
                steps_completed: 10,
              },
            },
            "core",
            user?.token ||
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
          );
          setCurrentStep((prev) => prev + 1); // move to next step

          // ❌ Rejected condition
        } else if (
          hasSuccess === "Success" &&
          decision === "Rejected" &&
          callbackData.callbackCount > 0
        ) {
          setKycFailed(true);
          clearInterval(intervalId);
          console.error("KYC Rejected");
          toast.error("KYC Rejected. Please try again or contact support.");
          setLoading(false);
          setCallBackInProcess(false);
          throw new Error("KYC Rejected. Please try again or contact support."); // or use toast/snackbar

          // ⏳ Max attempts condition
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          toast.error(
            "Max polling attempts reached without meeting success criteria"
          );
          setLoading(false);
          setCallBackInProcess(false);
          setkycFailedByNotTry(true);
          // console.warn(
          //   "Max polling attempts reached without meeting success criteria"
          // );
        }
      } catch (err) {
        console.error("Error checking KYC status", err);
        //setCallBackInProcess(false)
      } finally {
        //setCallBackInProcess(false);
      }
    };

    intervalId = setInterval(checkKYCStatus, 5000);

    return () => clearInterval(intervalId); // cleanup on unmount
  }, [kycUrl, appId]);

  return (
    <div className="w-full max-w-[400px] mx-auto min-h-[100dvh] bg-gray-100 flex flex-col">
      {/* Header */}
      <Header />

      {/* Iframe */}
      <div className="flex-1 min-h-[calc(100dvh-82px)] relative">
        {loading && (
          <div className="absolute inset-0 flex  flex-col items-center justify-center bg-gray-100 z-10">
            <Spinner />
            <p className="text-gray-700 text-lg">Loading KYC application...</p>
          </div>
        )}
        {callBackInProcess && (
          <div className="absolute inset-0 flex  flex-col items-center justify-center bg-gray-100 z-10">
            <Spinner />
            <p className="text-gray-700 text-lg text-center">
              {" "}
              Your eKYC confirmation is in progress. <br />
              Please do not close this page.
            </p>
          </div>
        )}

        {kycFailed && (
          <div className="absolute inset-0 flex flex-col items-center justify-center  z-10 p-6">
            <AlertCircle className="w-16 h-16 text-red-600 mb-4 animate-pulse" />
            <h2 className="text-2xl font-semibold text-red-700 mb-2">
              KYC Verification Failed
            </h2>
            <p className="text-red-600 text-center max-w-xs">
              Your KYC application could not be verified. Please check your
              documents and try again.
            </p>
          </div>
        )}

        {kycFailedByNotTry && (
          <div className="absolute inset-0 flex flex-col items-center justify-center  z-10 p-6">
            <AlertCircle className="w-16 h-16 text-red-600 mb-4 animate-pulse" />
            <h2 className="text-2xl font-semibold text-red-700 mb-2">
              KYC Verification Failed
            </h2>
            <button
              onClick={() => {
                if (kycUrl) {
                  window.location.href = kycUrl; // Redirect to KYC URL
                }
              }}
              className="bg-green-700 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Start KYC
            </button>
          </div>
        )}

        {/* {kycUrl && (
          <iframe
            src={kycUrl}
            title="KYC Application"
            className="w-full h-[100vh] border-0"
            allowFullScreen
            onLoad={() => setLoading(false)}
          />
        )} */}
      </div>
    </div>
  );
}
